import cloneDeep from 'lodash/cloneDeep'
import {
    INIT_BATTLE, PROGRESS_BATTLE, SET_BATTLE_BANNER, RESET_BATTLE,
} from '../../actions/game/battle.actions'

const initialState = {}

const battleReducer = (state = initialState, action) => {
    const { payload } = action

    switch (action.type) {
        case INIT_BATTLE: {
            const { stage, squadUnits } = payload
            return {
                stage,
                squadUnits,
                currentStep: 0,
                currentPhase: -1,
                currentStatus: 'hold',
                currentBanner: '',
            }
        }

        case PROGRESS_BATTLE: {
            const { step, phase, status } = payload
            return Object.assign(
                {},
                cloneDeep(state),
                {
                    currentStep: step,
                    currentPhase: phase,
                    currentStatus: status,
                }
            )
        }

        case SET_BATTLE_BANNER: {
            const { banner } = payload
            return Object.assign(
                {},
                cloneDeep(state),
                {
                    currentBanner: banner,
                }
            )
        }

        case RESET_BATTLE: {
            return initialState
        }

        default: {
            return state
        }
    }
}

export default battleReducer
